import React from 'react';

import '../css/Themes.css';

import NavBar from '../composant/NavBar';
import Header from '../composant/Header';

function Base(){
    return (
        <div className='base'>
            <Header data={{
                title: `Orchidée | Membres`,
                favicon: {
                    data: {
                        attributes: {
                            url: 'https://res.cloudinary.com/orchidee/image/upload/v1672523627/Orchidee_White_73d9d285a3.png'
                        }
                    }
                }
            }}></Header>
            <NavBar></NavBar>
            <div className='Layout_colorBackground__Adyt4'></div>
            <div className='Layout_colorBackgroundBottom__9Yf_q'></div>
        </div>
    )
}

export default Base;